import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-area-select-item',
  templateUrl: './area-item.component.html',
  styles: [],
  standalone: false
})
export class AreaSelectItemComponent {
  @Input() area: any = {};

  typeColor: { [key: number]: string } = {
    0: '#87d068', // Both
    1: '#2db7f5', // Customer Only
    2: '#f25f12'  // Supplier Only
  };
  
  typeLabel: { [key: number]: string } = {
    0: 'Both',
    1: 'Customer Only',
    2: 'Supplier Only'
  };

  constructor() {}
}
